
import React from 'react'

const Layout = (props) => {

    return (
        <div className="main-layout">

            {props.children}
            <div className='footer-app' />
        </div>
    )
}
export default Layout
